import { render } from "./SplitBill.vue?vue&type=template&id=2a9cae0f&ts=true"
import script from "./SplitBill.vue?vue&type=script&lang=ts"
export * from "./SplitBill.vue?vue&type=script&lang=ts"

import "./SplitBill.vue?vue&type=style&index=0&id=2a9cae0f&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__